// © Microsoft Corporation. All rights reserved.
export function stringHasData(value) {
    return (typeof value === "string" && (value.trim().length > 0));
}
//# sourceMappingURL=Utility.js.map